import React from 'react';
import { ServiceRegistry } from '../../../core/ServiceRegistry';
import { gameLogger } from '../../../../utils/GameLogger';
import { LevelOverview } from './Map/LevelOverview';
import { PlatformList } from './Map/PlatformList';
import { TeleporterDetails } from './Map/TeleporterDetails';
import { SpawnPointDetails } from './Map/SpawnPointDetails';
import { buttonStyle } from './Map/styles';

export const MapToolsTab: React.FC = () => {
  const mapSystem = ServiceRegistry.getInstance().get('MapSystem');
  const level = mapSystem?.getCurrentLevel();
  const teleporters = mapSystem?.getTeleporters() || [];

  if (!level) {
    return (
      <div style={{ textAlign: 'center', color: '#888', padding: '20px' }}>
        No level loaded
      </div>
    );
  }

  return (
    <>
      <LevelOverview level={level} />
      <PlatformList platforms={level.platforms || []} />
      <TeleporterDetails teleporters={teleporters} />
      <SpawnPointDetails spawnPoints={level.spawnPoints || []} />

      <button
        style={{ ...buttonStyle, marginTop: '20px', background: '#27ae60', borderColor: '#2ecc71', textAlign: 'center', fontWeight: 'bold' }}
        onClick={() => {
          gameLogger.info('dev', 'Current Level Data:', level);
          gameLogger.info('dev', 'Teleporters:', teleporters);
          alert('Level data logged to console!');
        }}
      >
        📋 Export Level to Console
      </button>
    </>
  );
};
